import { render } from "./Loading.vue?vue&type=template&id=cbf79a7a&scoped=true&ts=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=cbf79a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf79a7a"]])

export default __exports__